<template>
  <div class="introduce-wrap">
    <ul class="introduce-list1">
      <li class="introduce-icon1">
        <b>1、活动时间：</b><span class="yellow">2018年9月22日9点-9月28日23点59分</span>
      </li>
      <li class="introduce-icon2">
        <b>2、抽奖规则：</b>
        <ul class="introduce-list2">
          <li><span>1</span><b class="yellow">每位用户共有七次抽奖机会</b>，每日仅有一次抽奖机会，每日
          <b class="yellow">0时重置</b>抽奖次数；</li>
          <li><span>2</span>为保证抽奖的公平性，同一奖品不会重复抽到。
          所有的奖励只能获得1次，但<b class="yellow">不会重复抽到</b>。</li>
          <li><span>3</span>礼包兑换步骤：<b class="yellow">①</b>复制抽到的礼包码
          <b class="yellow">②</b>进入游戏，点击头像（设置）
          <b class="yellow">③</b>点击【礼包码】
          <b class="yellow">④</b>输入礼包码兑换奖励（注：游戏内角色达5级以上才可以兑换哦~）</li>
          <li>
            <span>4</span>新用户兑换步骤：<b class="yellow">①</b>扫描以下二维码下载游戏
            <b class="yellow">②</b>根据以上兑换步骤完成礼包码兑换
            <p class="wxcode">
              <img :src="codeLink">
            </p>
          </li>
        </ul>
      </li>
      <li class="introduce-icon3">
        <b>3、</b>为了您的利益，请<b class="yellow">及时完善您的收货地址</b>，便于我们寄送 实物奖励，请在页面 "填写收货地址"处完善您的资料信息。
      </li>
      <li>
        <b>4、</b>本次活动仅限于【黑马手游】公众号粉丝可参加
      </li>
      <li>
        <b>5、</b>活动结束后，实物获奖名单将在【黑马手游】公众号上发布， 实物奖励将于活动结束后<b class="yellow">15个工作日</b>内发放。
      </li>
      <li>
        <b>6、</b>如玩家使用外挂、作弊器或其他不正当方式参与本活动， 黑马有权收回您非法获得的全部礼品，并就相关行为给予处罚。
      </li>
      <li>
        <b>7、</b>所有礼包码可供<b class="yellow">全服的玩家使用，10月30日过期</b>，请获奖玩家及时兑换。
      </li>
      <li>
        <b>8、</b>本次活动最终解释权归<b class="yellow">黑马手游</b>所有。
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      codeLink: '',
    };
  },
  created() {
    const isWx = /MicroMessenger/i.test(navigator.userAgent.toLowerCase());
    if (isWx) {
      this.codeLink = '//res.aidalan.com/hd/sg/img/wxcode2.jpg';
    } else {
      this.codeLink = '//res.aidalan.com/hd/sg/img/wxcode.jpg';
    }
  },
};
</script>

<style>
.introduce-wrap{
  padding: 2% 2.5% 10%;
  color: #fff;
  font-size: 13px;
}
.introduce-list1>li{
  margin: .5em 0;
  padding-left: 2.8em;
}
.introduce-icon1, .introduce-icon2, .introduce-icon3{
  min-height: 2.4em;
  padding-top: .4em;
}
.introduce-icon1{
  background: url(//res.aidalan.com/hd/sg/img/icon1.png) no-repeat;
  background-size: 2.4em;
}
.introduce-icon2{
  background: url(//res.aidalan.com/hd/sg/img/icon2.png) no-repeat;
  background-size: 2.4em;
  border-bottom: 1px dotted #fff;
}
.introduce-icon3{
  background: url(//res.aidalan.com/hd/sg/img/icon3.png) no-repeat;
  background-size: 2.4em;
}
.introduce-list2 li{
  position: relative;
  padding-left: 1.5em;
  margin: .1em 0;
}
.introduce-list2 span{
  position: absolute;
  left: 0;
  top: .16em;
  line-height: 1em;
  width: 1em;
  height: 1em;
  background-color: #fee300;
  color: #b42926;
  text-align: center;
  border-radius: 1em;
}
.wxcode{
  width: 50%;
  max-width: 200px;
  margin: 5% auto;
  transform: translateX(-2.15em);
}
.wxcode img{
  width: 100%;
}
.yellow{
  color: #fee300;
  font-weight: normal;
}
</style>




// WEBPACK FOOTER //
// src/components/Introduce.vue